/**
 * MPCI Local Dropdown Options
 * Source: DB-FIELD-CODED-VALUES.md
 * Format: { text: 'display label', value: 'stored code' }
 */

// Filing Operator (MBL)
export const FILING_OPERATOR_MBL = [
  { text: 'SL - Shipping Line', value: 'SL' },
  { text: 'SA - Shipping Agent', value: 'SA' }
]

// Filing Operator (HBL)
export const FILING_OPERATOR_HBL = [
  { text: 'Liable Freight Forwarder', value: 'LFF' },
  { text: 'Delegated Freight Forwarder', value: 'DFF' }
]

// Document Type (MBL)
export const DOC_TYPE_MBL = [
  { text: 'Yes', value: '704' },
  { text: 'No', value: '705' }
]

// Document Type (HBL)
export const DOC_TYPE_HBL = [
  { text: 'Yes', value: '716' },
  { text: 'No', value: '714' }
]

// Processing Indicator
export const PROCESSING_INDICATOR = [
  { text: 'Y - Negotiable', value: 'Y' },
  { text: 'N - Non-Negotiable', value: 'N' }
]

// Shipment Type (HBL)
export const SHIPMENT_TYPE_HBL = [
  { text: 'Import', value: '23' },
  { text: 'Transit', value: '24' }
]

// Shipment Type (MBL)
export const SHIPMENT_TYPE_MBL = [
  { text: 'Import', value: '23' },
  { text: 'Transit', value: '24' },
  { text: 'Transshipment', value: '28' },
  { text: 'Freight Remaining on Board', value: '165' }
]

// Function Type
export const FUNCTION_TYPE = [
  { text: 'NEW - Original Bill', value: 'NEW' },
  { text: 'CXL - Cancellation', value: 'CXL' },
  { text: 'CHG - Change/Update', value: 'CHG' },
  { text: 'RIR - Response to RFI (Respond)', value: 'RIR' },
  { text: 'RIJ - Response to RFI (Reject)', value: 'RIJ' },
  { text: 'SPL - Split Bill', value: 'SPL' },
  { text: 'OSP - Original Split', value: 'OSP' },
  { text: 'SWB - Switch Bill', value: 'SWB' }
]

// Emirate
export const EMIRATE = [
  { text: 'AZ - Abu Dhabi', value: 'AZ' },
  { text: 'DU - Dubai', value: 'DU' },
  { text: 'SH - Sharjah', value: 'SH' },
  { text: 'UQ - Umm Al Quwain', value: 'UQ' },
  { text: 'AJ - Ajman', value: 'AJ' },
  { text: 'FU - Al Fujairah', value: 'FU' },
  { text: 'RK - Ras Al Khaimah', value: 'RK' }
]
